import { render, staticRenderFns } from "./DroppableMixin.js.vue?vue&type=template&id=2fb628c2&"
import script from "./DroppableMixin.js.vue?vue&type=script&lang=js&"
export * from "./DroppableMixin.js.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports